import * as apiTo from '../api'

export default {
  namespaced: true,

  state() {
    return {
      spreadsheetInformation: null
    }
  },

  mutations: {
    setSpreadsheetInformation: (state, payload) => (state.spreadsheetInformation = payload)
  },

  actions: {
    getSpreadsheetInformation({ commit }) {
      return apiTo.getSpreadsheetInformation().then(({ data }) => commit('setSpreadsheetInformation', data.result))
    }
  }
}
